import * as types from '~/store/rebooking/rebookingType';

const initialState = {
  rebooking: {},
  rebookingSelected: null,
  loading: false,
  errorMessage: '',
  searchHistoryList: [],
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.SHOW_LOADING:
      return { ...state, loading: true };
    case types.HIDE_LOADING:
      return { ...state, loading: false };

    case types.CLEAR_STATE: {
      return { ...initialState };
    }
    case types.SELECT_REBOOKING: {
      return {
        ...state,
        rebookingSelected: action.rebookingSelected,
      };
    }
    case types.GET_ALL_REBOOKING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_ALL_REBOOKING_SUCCESS: {
      return {
        ...state,
        rebooking: action.data,
        errorMessage: '',
        loading: false,
      };
    }
    case types.GET_ALL_REBOOKING_FAILURE:
      return {
        ...state,
        rebooking: {},
        errorMessage: action.errorMessage,
        loading: false,
      };

    case types.GET_ALL_PATIENT_REBOOKING_SUCCESS:
      return {
        ...state,
        searchHistoryList: action.searchHistoryList,
        errorMessage: '',
      };
    case types.GET_ALL_PATIENT_REBOOKING_FAILURE:
      return {
        ...state,
        errorMessage: action.errorMessage,
      };

    default:
      return state;
  }
};
